import { IoIosAdd } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  margin: -16px -16px -32px;

  @media ${({ theme }) => theme.device.desktop} {
    margin: -16px 0 -32px;
  }
`;

export const Header: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  margin: 0 16px;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0;
  }
`;
Header.Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
  margin: 16px 0 0;
  line-height: normal;
`;
Header.Sub = styled.p`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};
  margin: 0;
`;

export const Close: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
Close.Icon = styled(IoIosAdd)`
  font-size: 25px;
  transform: rotate(45deg);
  color: ${ColorPalette.HEX.PineTree};
`;

export const List = styled.ul`
  padding: 0;
  overflow: auto;
  max-height: calc(100vh - 370px);

  @media ${({ theme }) => theme.device.desktop} {
    max-height: calc(100vh - 100px);
  }
`;
export const Item = styled.li`
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 16px;
  border-bottom: 0.5px solid ${ColorPalette.HEX.Platinum2};
  margin: 16px 16px 0 16px;
  &:last-child {
    border-bottom: none;
  }
  @media ${({ theme }) => theme.device.desktop} {
    margin: 16px 0 0;
    cursor: pointer;
  }
`;
